import { safeWindowOpen } from '~/helpers/safeUrlOpen.ts';
import {
  documentPreviewPersonalDataTable,
  revokeDocumentPreviewPersonalDataTable,
} from '~/store/processing-personal/thunks/documentPreviewPersonalThunks.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';
import { OBJECT_URL_REVOKE_DELAY_MS } from '../constants.ts';
import { TDocumentType } from '../types.ts';

export const useDocumentClick = (type: TDocumentType) => {
  const dispatch = useAppDispatch();

  const handleDocumentClick = async (appId: string, appDocId: string) => {
    if (!appId || !appDocId) {
      return;
    }

    try {
      const previewThunkByType = {
        submit: documentPreviewPersonalDataTable,
        revoke: revokeDocumentPreviewPersonalDataTable,
      } as const;
      const previewResult = await dispatch(
        previewThunkByType[type]({
          applicationId: appId,
          applicationDocumentId: appDocId,
        })
      ).unwrap();
      const fileURL = previewResult.fileURL;

      if (!fileURL || typeof fileURL !== 'string') {
        return;
      }

      const isOpened = safeWindowOpen(fileURL, { base: window.location.origin });

      if (!isOpened) {
        const link = document.createElement('a');
        link.href = fileURL;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      window.setTimeout(() => window.URL.revokeObjectURL(fileURL), OBJECT_URL_REVOKE_DELAY_MS);
    } catch (error) {
      console.error('useDocumentClick failed to open document preview:', error);
    }
  };

  return handleDocumentClick;
};
